import { ApplicantStatus } from "./components/ApplicantStatus";
import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import { SignIn } from "./components/SignIn";
import { SignUp } from "./components/SignUp"
import { ChangePassword } from "./components/ChangePassword";
import { ChangePasswordEmail } from "./components/ChangePasswordEmail";
import { ResendEmail } from "./components/ResendEmail";

const AppRoutes = [
  {
    element: <Home />
    },
  {
      index: true,
      path: '/*',
      element: <SignIn />
    },
  {
      path: '/sign-up',
      element:<SignUp />
    },
  {
      path: '/change-password',
      element: <ChangePassword />
    },
    {
        path: '/change-password-email',
        element: <ChangePasswordEmail />
    },
  {
    path:'/applicantstatus',
    element:<ApplicantStatus />
  },
  {
    path:'/resend-email',
    element: <ResendEmail />
  },
  {
    path: '/counter',
    element: <Counter />
  },
  {
    path: '/fetch-data',
    element: <FetchData />
  }
];

export default AppRoutes;
